import React, { Component } from 'react';

import { Dialog } from '~/components';
import StockList from '~/pages/Operacao/EstoqueTanque';

class Stations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      params: {},
    };
  }

  // Toggle modal
  async handleToggleModal(params = {}) {
    this.setState((prevState) => ({
      open: !prevState.open,
      params,
    }));
  }

  render() {
    const { open, params } = this.state;

    return (
      <Dialog
        open={open}
        title={params.nomeposto}
        toggle={() => this.handleToggleModal()}
      >
        <StockList
          hidden
          limit={20}
          unique={{
            wherefield: ['idposto'],
            valuewherefield: [params.idposto],
            typewherefield: ['EQUALS'],
          }}
        />
      </Dialog>
    );
  }
}

export default Stations;
